export function getDiscountDisplay(item) {
  return typeof item?.discountDisplay === 'string' ? item.discountDisplay.trim() : ''
}

export function getSkuOptionDiscountDisplay(skus, selected, specId, valueId) {
  if (!Array.isArray(skus)) return ''
  const candidates = skus.filter(sku => {
    const ids = String(sku?.spItemSkuSpecificationIds || '').split(',').map(id => id.trim())
    return ids.includes(`${specId}-${valueId}`)
      && Object.entries(selected || {}).every(([key, value]) => (
        String(key) === String(specId) || ids.includes(`${key}-${value}`)
      ))
  })
  // An incomplete selection must not borrow a discount from a different SKU.
  const labels = new Set(candidates.map(getDiscountDisplay))
  return labels.size === 1 ? [...labels][0] : ''
}
